import {mapGetters} from "vuex";

export default {
    data() {
        return {};
    },
    computed: {
        ...mapGetters(['set_project_value', 'set_building_value', 'set_user_object', 'set_item_equipment_data',
              'set_new_energy_attr_list', 'set_new_item_attr_list',
              'set_role_data', 'set_new_auth_data',
               'set_build_info','set_funcGrounp_value','set_plat_info',
            ]),
    },
    methods: {
        $get_function(Data, value) {
            if (Data.obj === 'project') {
                this.set_project_value(Data.data.c_code, value)
            }  else if (Data.obj === 'funcGrounp') {
                this.set_funcGrounp_value(Data.data.c_code, value)
            }
            else if (Data.obj === 'building') {
                this.set_building_value(Data,Data.data.c_code, value)
            }  else if (Data.obj === 'role') {
                this.set_role_data(Data.data.c_code, value)
            } else if (Data.obj === 'new_item') {
                this.set_new_item_attr_list(Data.data.c_code, value)
            } else if (Data.obj === 'new_energy') {
                this.set_new_energy_attr_list(Data.data.c_code, value)
            }else if (Data.obj === 'new_auth') {
                this.set_new_auth_data(Data.data.c_id, value)
            }  else if (Data.obj === 'build_temp') {//新建项目：建筑信息
                this.set_build_info(Data, Data.data.c_code, value)
            } else if (Data.obj === 'plat') {//新建平台：平台信息
                console.log(Data, value,'e3r')

                this.set_plat_info(Data, Data.data.c_code, value)
            }
        },
        $get_objects(Data, value) {
          if (Data.obj === 'item_equipment') {//能耗模型管理-分类关联设备
                this.set_item_equipment_data(value)
            }
        },
    }
}